import React from "react";
import { useQuoteContext } from "../../../context-api/quote-context";
import { Link } from "react-router-dom";
import { flueData } from "../utils/flueData";

const QuestEight = () => {
  const { flueClick } = useQuoteContext();
  return (
    <section className="questions-section section-wrapper">
      <div className="question-header">
        <h1 className="quote-question-title">Where does your flue come out?</h1>
      </div>
      <div className="question-card-section">
        {flueData.map((item, index) => {
          const { title, image } = item;
          return (
            <Link
              className="question_link"
              key={index}
              to="/postcode"
              onClick={() => flueClick(title)}
            >
              <div className="question-card">
                <div className="question-card-img">
                  <img src={image} alt={title} />
                </div>
                <div className="question-card-text">
                  <h5 className="subtitle question_subtitle">{title}</h5>
                </div>
              </div>
            </Link>
          );
        })}
      </div>
    </section>
  );
};

export default QuestEight;
